import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TestResultAction } from '../../../../shared/models/test-result.model';
import { Role } from '../../../../shared/models/user.model';
import { LiveNumberTestingService } from '../../../../shared/services/live-number-testing.service';
import { UsersService } from '../../../../shared/services/users.service';

@Component({
  standalone: false,
  selector: 'app-lnt-actions',
  templateUrl: './lnt-actions.component.html',
  styleUrls: ['./lnt-actions.component.scss'],
})
export class LntActionsComponent implements ICellRendererAngularComp {
  constructor(
    private userService: UsersService,
    private liveNumberTestingService: LiveNumberTestingService
  ) {}

  currentRow: TestResultAction;
  showAppscriptsUserIcon = true;

  agInit(params: ICellRendererParams): void {
    this.currentRow = params.data;
    this.showAppscriptsUserIcon = this.userService.authUser.role === Role.ADMIN;
  }

  refresh() {
    return true;
  }

  get relatedTestName(): 'original test' | 'backup test' {
    return this.currentRow.retry ? 'original test' : 'backup test';
  }

  onClick(clickedItem: string) {
    this.liveNumberTestingService.announceAction({ name: clickedItem, row: this.currentRow, column: 'action' });
  }
}
